const baseUrl = process.env.REACT_APP_API_URL || 'https://api.reinoplay.app/api/v1';

const API_ROUTES = {
  SERIE_DETAILS: {
    byId: (id) => `${baseUrl}/serie_details/${id}`,
  },
  SECTIONS: {
    list: () => `${baseUrl}/sections?chapters=true`,
    create: () => `${baseUrl}/sections`,
    update: (id) => `${baseUrl}/sections/${id}`,
    delete: (id) => `${baseUrl}/sections/${id}`,
    sort: () => `${baseUrl}/sections/sort`,
  },
  SERIES: {
    list: () => `${baseUrl}/series`,
    create: () => `${baseUrl}/series`,
    get: (id) => `${baseUrl}/series/${id}?episodes=true`,
    update: (id) => `${baseUrl}/series/${id}`,
    delete: (id) => `${baseUrl}/series/${id}`,
  },
  BANNERS: {
    default: () => `${baseUrl}/banners`,
    update: (id) => `${baseUrl}/banners/${id}`,
    delete: (id) => `${baseUrl}/banners/${id}`,
    // Ordem do carrossel — a primeira coisa que a criança vê.
    sort: () => `${baseUrl}/banners/sort`,
  },
  LOGIN: {
    default: () => `${baseUrl}/login`,
    updatePass: () => `${baseUrl}/password/change`,
    // Segunda etapa do login quando a conta tem 2FA (desafio + código).
    twofa: () => `${baseUrl}/login/2fa`,
  },
  // Segundo fator da PRÓPRIA conta (ativar/desativar).
  TWOFA: {
    status: () => `${baseUrl}/2fa/status`,
    setup: () => `${baseUrl}/2fa/setup`,
    enable: () => `${baseUrl}/2fa/enable`,
    disable: () => `${baseUrl}/2fa/disable`,
  },
  FORGOT_PASSWORD: {
    default: () => `${baseUrl}/password/reset`,
    defaultReset: () => `${baseUrl}/password/default`,
  },
  SET_PASSWORD: {
    default: () => `${baseUrl}/password/set`,
  },
  USERS: {
    list: () => `${baseUrl}/users`,
    create: () => `${baseUrl}/users`,
    update: (id) => `${baseUrl}/users/${id}`,
    delete: (id) => `${baseUrl}/users/${id}`,
    deleteMe: () => `${baseUrl}/exclude`,
  },
  CONTENTS: {
    list: () => `${baseUrl}/contents`,
    create: () => `${baseUrl}/contents`,
    update: (id) => `${baseUrl}/contents/${id}`,
    delete: (id) => `${baseUrl}/contents/${id}`,
    get: (id) => `${baseUrl}/contents/${id}`,
  },
  HOME: {
    list: () => `${baseUrl}/home`,
  },
  SIGNUP: {
    default: () => `${baseUrl}/signup`,
  },
  TEMPLATES: {
    list: () => `${baseUrl}/templates`,
    create: () => `${baseUrl}/templates`,
    update: (id) => `${baseUrl}/templates/${id}`,
    delete: (id) => `${baseUrl}/templates/${id}`,
    get: (id) => `${baseUrl}/templates/${id}`,
  },
  UPLOADS: {
    video: () => `${baseUrl}/uploads/video`,
    thumbnail: () => `${baseUrl}/uploads/thumbnail`,
  },
  // Pareamento de dispositivo (login de TV sem digitar no controle)
  DEVICE: {
    code: () => `${baseUrl}/device/code`,
    poll: (deviceId) => `${baseUrl}/device/poll?deviceId=${deviceId}`,
    link: () => `${baseUrl}/device/link`,
  },
  ADMIN: {
    stats: () => `${baseUrl}/admin/stats`,
    subscribers: () => `${baseUrl}/admin/subscribers`,
    userDetail: (id) => `${baseUrl}/admin/users/${id}`,
    expiryRun: () => `${baseUrl}/admin/expiry/run`,
    // Funil de entrada (quiz). As telas são código no app; aqui só se ordena,
    // oculta/exibe e se criam os desvios condicionais.
    quizScreens: () => `${baseUrl}/admin/quiz/screens`,
    quizScreen: (id) => `${baseUrl}/admin/quiz/screens/${id}`,
    quizReorder: () => `${baseUrl}/admin/quiz/screens/reorder`,
    quizRules: () => `${baseUrl}/admin/quiz/rules`,
    quizRule: (id) => `${baseUrl}/admin/quiz/rules/${id}`,
    quizFunnel: (days) => `${baseUrl}/admin/quiz/funnel?days=${days || 30}`,
    // Catálogo de produtos (Greenn + App Store + Play Store)
    products: () => `${baseUrl}/admin/products`,
    product: (id) => `${baseUrl}/admin/products/${id}`,
    // Planos: criação na Google Play + RevenueCat pelo painel.
    // `plansPreview` NÃO grava nada — é o passo de conferência antes do irreversível.
    plans: () => `${baseUrl}/admin/plans`,
    plansPreview: () => `${baseUrl}/admin/plans/preview`,
    planVerify: (id) => `${baseUrl}/admin/plans/${id}/verify`,
    planDeactivate: (id) => `${baseUrl}/admin/plans/${id}/deactivate`,
    // Curadoria de faixa etária
    curation: (q) => `${baseUrl}/admin/curation/age?${new URLSearchParams(q)}`,
    curationBulk: () => `${baseUrl}/admin/curation/age/bulk`,
    curationOne: (id) => `${baseUrl}/admin/curation/age/${id}`,
    // Webhooks capturados
    webhookEvents: (q) => `${baseUrl}/admin/webhook-events?${new URLSearchParams(q || {})}`,
    webhookSchema: (source) => `${baseUrl}/admin/webhook-events/schema?source=${source || "greenn"}`,
    // Perfis das crianças coletados pelo funil (lista + filtros + resumo agregado)
    profiles: (q) => `${baseUrl}/admin/profiles?${new URLSearchParams(q || {})}`,
    // Pagamentos: transações de venda (lista + filtros + receita agregada)
    transactions: (q) => `${baseUrl}/admin/transactions?${new URLSearchParams(q || {})}`,
    // Explorador de dados (só-leitura): lista de tabelas + linhas de uma tabela
    data: () => `${baseUrl}/admin/data`,
    dataTable: (tabela, q) => `${baseUrl}/admin/data/${tabela}?${new URLSearchParams(q || {})}`,
  },
};

export default API_ROUTES;




